import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

@Component({
  selector: 'fdr-past-performance-ui-base-card',
  imports: [],
  templateUrl: './base-card.component.html',
  styleUrl: './base-card.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BaseCardComponent {

  readonly title = input.required<string>();
  readonly subtitle = input<string>();

}
